import { useEffect } from "react";
import { getMedication } from "../../../apiHandler/actions/profile";
import { DataGridCustomPagination } from "../../helpers";
import { Skeleton } from "@material-ui/lab";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "name", headerName: "Medication Name", flex: 1 },
  { field: "duration", headerName: "Duration", flex: 1 },
  { field: "frequency", headerName: "Frequency", flex: 1 },
];

const Component = (props) => {
  const { medication, setMedication } = props;

  useEffect(() => {
    if (medication === null) fetchMedication();
    // eslint-disable-next-line
  }, []);

  const fetchMedication = async () => {
    const response = await getMedication(props.uuid);
    setMedication(
      response.medicationStatement &&
        response.medicationStatement.map((m) => {
          return {
            id: m.id,
            name: m.contained[0]?.code?.coding[0]?.display,
            frequency: m.dosage[0]?.text,
            duration: m.dosage[0]?.timing?.repeat?.boundsDuration.value,
          };
        })
    );
  };

  return (
    <div>
      {medication === null ? (
        <div className="mj-skeleton-container">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : Array.isArray(medication) && medication.length !== 0 ? (
        <DataGrid
          rows={medication}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={5}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      ) : (
        <p className="mj-no-records">No records to display</p>
      )}
    </div>
  );
};

export default Component;
